import { combineReducers } from 'redux';

import { ACTION_ADD_AFFILIATED_USERS } from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_AFFILIATED_USERS:
      return { ...state, ...action.payload.affiliatedUsers };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
